import { lazy, Suspense, useEffect, useState } from "react";
import { fetchPublicConciergeConfig } from "../lib/api";

const PublicConciergeWidget = lazy(() => import("./PublicConciergeWidget"));

/**
 * Gate around the Public Concierge widget.
 *
 * Fetches the widget-relevant flags from the Platform API and only
 * mounts the widget when `FEATURE_PUBLIC_CONCIERGE` is enabled for the
 * resolved tenant. Fails closed (no widget) on any error so a Platform
 * outage never breaks the public site.
 */
export default function PublicConciergeGate() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const cfg = await fetchPublicConciergeConfig();
        if (alive) setEnabled(!!cfg?.publicConciergeEnabled);
      } catch {
        // Fail-closed: no widget on any read error.
        if (alive) setEnabled(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  if (!enabled) return null;
  return (
    <Suspense fallback={null}>
      <PublicConciergeWidget />
    </Suspense>
  );
}
